import { defineStore } from 'pinia'
import { authService } from '@/services/auth.service'

// Constantes pour l'adhésion
export const MEMBERSHIP_FEE = 10
export const MEMBERSHIP_NAME = "Adhésion annuelle Zebu"

export const useTemporaryCartStore = defineStore('temporaryCart', {
  state: () => ({
    selectedPlan: null,
    isGift: false,
    giftData: null,
    pricing: null,
    loading: false,
    error: null
  }),

  getters: {
    total() {
      return this.pricing?.total?.amount || 0
    },
    
    membership() {
      return this.pricing?.membership || null
    },

    plan() {
      return this.pricing?.plan || null
    }
  },

  actions: {
    async setPlan(plan, isGift = false, giftData = null) {
      this.loading = true
      this.error = null
      
      try {
        // Récupérer les informations de prix
        const response = await authService.getPlanPricing(plan.projectId)
        if (response.success) {
          this.pricing = response.pricing
          this.selectedPlan = {
            ...plan,
            ...response.pricing.plan
          }
          this.isGift = isGift
          this.giftData = giftData
          
          // Sauvegarder dans le localStorage
          this.saveToStorage()
        } else {
          throw new Error('Impossible de récupérer les informations de prix')
        }
      } catch (error) {
        this.error = error.message || 'Une erreur est survenue'
        throw error
      } finally {
        this.loading = false
      }
    },

    clearPlan() {
      this.selectedPlan = null
      this.isGift = false
      this.giftData = null
      this.pricing = null
      this.error = null
      localStorage.removeItem('tempCart')
    },

    saveToStorage() {
      localStorage.setItem('tempCart', JSON.stringify({
        plan: this.selectedPlan,
        isGift: this.isGift,
        giftData: this.giftData,
        pricing: this.pricing
      }))
    },

    loadFromStorage() {
      const stored = localStorage.getItem('tempCart')
      if (stored) {
        const { plan, isGift, giftData, pricing } = JSON.parse(stored)
        this.selectedPlan = plan
        this.isGift = isGift
        this.giftData = giftData
        this.pricing = pricing
      }
    }
  }
}) 